export function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName = 'ANONYMOUS', location) {
        if (props[propName] == null) {
            if (isRequired) {
                return new Error(
                    `Required ${location} \`${propName}\` was not specified in `
                    + `\`${componentName}\`.`,
                );
            }
            return null;
        }

        return validate(props, propName, componentName, location);
    }

    let chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}
